(function Module() {
	'use strict';
	//jshint expr: true

	var _ = require('lodash');
	var format = require('./format');
	var label = require('./label');
	var units = require('./units');

	// declare the constructor for a class
	function I18n() {
		// @private vars
		this.privateRegion;
	}

	var possibleRegions = [
		{key: 'usa', value: 'USA', shortCode: 'US'},
		{key: 'aus', value: 'AUS', shortCode: 'AU'}
	];
	var defaults = {
		region: possibleRegions[0],
		format: format.international,
		label: label.international,
		units: units.international
	};

	// declare the property accessors on the prototype
	Object.defineProperty(I18n.prototype, 'region', {
		get: function getRegion() {
			return this.privateRegion || defaults.region;
		},

		set: function setRegion(newRegion) {
			if (_.includes(_.map(possibleRegions, 'value'), newRegion)) {
				this.privateRegion = _.find(possibleRegions, {value: newRegion});
			}
		}
	});

	Object.defineProperty(I18n.prototype, 'label', {
		get: function getLabel() {
			return label[this.region.key] || defaults.label;
		}
	});

	Object.defineProperty(I18n.prototype, 'format', {
		get: function getFormat() {
			return format[this.region.key] || defaults.format;
		}
	});

	Object.defineProperty(I18n.prototype, 'units', {
		get: function getUnits() {
			return units[this.region.key] || defaults.units;
		}
	});

	module.exports = new I18n();
})();
